import { makeAuthenticatedRequest } from "./api";

export const getTopRecommendations = async (classroomId, studentId) => {
  try {
    const URL = `/topics/${classroomId}/topRecommendations${
      studentId ? `?studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return {
          ok: true,
          data: {
            count: data.count,
            topics: data.topics.map((topic) => ({
              _id: topic._id,
              name: topic.name,
              score: topic.score,
              subjectId: topic.subjectId,
              attemptedPractices: topic.attemptedPractices || [],
              attemptedTests: topic.attemptedTests || [],
              unAttemptedPractices: topic.unAttemptedPractices || [],
              unAttemptedTests: topic.unAttemptedTests || [],
            })),
          },
        };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching top recommendations:", error);
    return { ok: false, error: error };
  }
};

export const getTopRecommendationsBySubjects = async (
  classroomId,
  subjectIds,
  studentId
) => {
  try {
    const subjectIdsParam = Array.isArray(subjectIds)
      ? subjectIds.join(",")
      : subjectIds;
    const URL = `/topics/${classroomId}/topRecommendations?subjectId=${subjectIdsParam}${
      studentId ? `&studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return {
          ok: true,
          data: {
            count: data.count,
            topics: data.topics.map((topic) => ({
              _id: topic._id,
              name: topic.name,
              score: topic.score,
              subjectId: topic.subjectId,
              attemptedPractices: topic.attemptedPractices || [],
              attemptedTests: topic.attemptedTests || [],
              unAttemptedPractices: topic.unAttemptedPractices || [],
              unAttemptedTests: topic.unAttemptedTests || [],
            })),
          },
        };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching top recommendations by subjects:", error);
    return { ok: false, error: error };
  }
};
